import { Button, Label, TextInput } from "flowbite-react";
import { useState } from "react";
import { UseFormRegisterReturn, UseFormSetFocus, UseFormSetValue } from "react-hook-form";
import { MdPersonSearch } from "react-icons/md";
import SupplierModal from "../../Modals/SupplierModal";


interface ModalFormSupplierFieldProps {
    register: UseFormRegisterReturn,
    errors: Record<string, any>,
    fieldName: string,
    label: string,
    placeholder: string,
    setValue: UseFormSetValue<any>,
    setFocus: UseFormSetFocus<any>
}

const ModalFormSupplierField = ({register, errors, fieldName, label, placeholder, setValue, setFocus}: ModalFormSupplierFieldProps) => {
    const [openModal, setOpenModal] = useState(false);

    const addSupplier = (supplierName: string) => {
        setValue("supplier", supplierName);
        setFocus("supplier");
        setOpenModal(false);
    }

    return (
        <div className="col-span-2">
            <div className="mb-2 block">
                <Label htmlFor={fieldName} value={label} />
            </div>
            <div className="flex">
                <div className="grow pr-2">
                    <TextInput
                        id={fieldName}
                        placeholder={placeholder}
                        {...register}
                    />
                </div>
                <div className="grow-0 w-14">
                    <Button onClick={() => setOpenModal(true)} color="yellow">
                        <MdPersonSearch className="h-5 w-5" />
                    </Button>
                </div>
            </div>
            {errors && errors[fieldName] && (
                <div className="text-red-500 text-xs pt-2">{errors[fieldName].message}</div>
            )}

            <SupplierModal openModal={openModal} setOpenModal={setOpenModal} addSupplier={addSupplier} />
        </div>
    )
}

export default ModalFormSupplierField;